module.exports = __webpack_public_path__ + "img/img_moa问题反馈.598697f0.png";